// extracted by mini-css-extract-plugin
module.exports = {"comp":"EarlyBird_JP_comp__RtaQC"};